import {
  BAR_NAME_FONT_SIZE,
  BAR_NAME_LINE_HEIGHT,
  MUTED,
} from './chuva-chart-constants';
import { wrapLabel } from './chuva-chart-utils';

interface BarAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value?: string | number };
}

const createBarAxisTick = (maxChars: number) => {
  const BarAxisTick = ({ x = 0, y = 0, payload }: BarAxisTickProps) => {
    const label = String(payload?.value ?? '').toUpperCase();
    const lines = wrapLabel(label, maxChars);
    const firstLineY = y - ((lines.length - 1) * BAR_NAME_LINE_HEIGHT) / 2;
    return (
      <text
        dominantBaseline="central"
        fill={MUTED}
        fontSize={BAR_NAME_FONT_SIZE}
        textAnchor="end"
        x={x}
        y={firstLineY}
      >
        <title>{label}</title>
        {lines.map((line, index) => (
          <tspan key={line} dy={index === 0 ? 0 : BAR_NAME_LINE_HEIGHT} x={x}>
            {line}
          </tspan>
        ))}
      </text>
    );
  };
  BarAxisTick.displayName = 'BarAxisTick';
  return BarAxisTick;
};

export default createBarAxisTick;
